import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

import ApiService from "./common/api.service"
import i18n from './i18n'

Vue.config.productionTip = false

ApiService.init();

new Vue({
  router,
  store,
  i18n,
  created: () => {
    console.log(window.localStorage.getItem('settings'));
    let settings = JSON.parse(window.localStorage.getItem('settings')) || {};
    if ('language' in settings) {
      i18n.locale = settings.language;
    }

  },
  render: h => h(App)
}).$mount('#app')

